
define('text!views/modals/dialogs/CookieDialog.html',[],function () { return '<div class="modal cookies-dialog big">\n    <div class="modal-header">\n        {{{title}}}\n        <a class="close" data-bind="click: close"><span class="icons-cross"></span></a>\n    </div>\n    <div class="modal-content pad" data-bind="scrollContainer: true">\n        {{{content}}}\n    </div>\n</div>\n';});

